import script from "./powerStationVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./powerStationVideo.vue?vue&type=script&setup=true&lang=js"

import "./powerStationVideo.vue?vue&type=style&index=0&id=2d50e844&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d50e844"]])

export default __exports__